var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{class:_vm.buttonClass,attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2):_c('button',{class:_vm.buttonClass,on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }